import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input, Checkbox } from "antd";
import { observer } from "mobx-react";
import { __, _i, _x } from "../../../utils";
import { PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM } from ".";
import { PluginUpdateLicenseTelemetryDataModal } from "..";
const PluginUpdateTermFields = observer((param)=>{
    let { pluginUpdate } = param;
    const PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM = {
        ...PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
        zoom: 0.8
    };
    const { privacyProvider, privacyPolicy, allowsTelemetry, allowsAutoUpdates, allowsNewsletter, additionalCheckboxes, licenses: [firstLicense] } = pluginUpdate;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            allowsAutoUpdates && /*#__PURE__*/ _jsx(Form.Item, {
                name: "autoUpdates",
                valuePropName: "checked",
                style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    children: _i(__("Updates containing bug fixes and new features will be downloaded and installed automatically."), {
                        a: /*#__PURE__*/ _jsx("a", {
                            href: privacyPolicy,
                            target: "_blank",
                            rel: "noreferrer"
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "terms",
                valuePropName: "checked",
                required: true,
                rules: [
                    {
                        type: "boolean",
                        required: true,
                        transform: (value)=>value || undefined,
                        message: __("Please confirm that you have read the privacy policy!")
                    }
                ],
                style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    children: _x("I allow to transfer technical data about this WordPress installation to the update server of %1$s and get latest announcements. This data is required for license activation and update functionality.", "legal-text", privacyProvider)
                })
            }),
            allowsTelemetry && /*#__PURE__*/ _jsx(Form.Item, {
                name: "telemetry",
                valuePropName: "checked",
                style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    children: _i(_x("I allow telemetry data about the use of this WordPress plugin to be collected in accordance with the %1$s {{a}}privacy policy{{/a}}. This data does not include any personal information about users of the plugin. Collected data ({{aDataExample}}open example of transmitted data{{/aDataExample}}) will be used to provide you with the best possible support and to improve the plugin.", "legal-text", privacyProvider), {
                        a: /*#__PURE__*/ _jsx("a", {
                            href: privacyPolicy,
                            target: "_blank",
                            rel: "noreferrer"
                        }),
                        aDataExample: /*#__PURE__*/ _jsx(PluginUpdateLicenseTelemetryDataModal, {
                            license: firstLicense,
                            linkWrapper: true
                        })
                    })
                })
            }),
            additionalCheckboxes.map((param)=>{
                let { id, text } = param;
                return /*#__PURE__*/ _jsx(Form.Item, {
                    name: id,
                    valuePropName: "checked",
                    style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                    children: /*#__PURE__*/ _jsx(Checkbox, {
                        children: text
                    })
                }, id);
            }),
            allowsNewsletter && /*#__PURE__*/ _jsx(Form.Item, {
                name: "newsletter",
                valuePropName: "checked",
                style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    children: _x("I would like to receive the %1$s newsletter with WordPress news, sales and product offers (approx. 1-2 per month) via email. I know that I can withdraw my consent for the newsletter at any time.", "legal-text", privacyProvider)
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.newsletter !== nextValues.newsletter,
                children: (param)=>{
                    let { getFieldValue } = param;
                    return getFieldValue("newsletter") && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                label: __("First name"),
                                name: "firstName",
                                style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
                                required: true,
                                rules: [
                                    {
                                        required: true,
                                        message: __("Please enter your first name!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Input, {})
                            }),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                label: __("Email"),
                                name: "email",
                                style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
                                required: true,
                                rules: [
                                    {
                                        type: "email",
                                        required: true,
                                        message: __("Please enter your email address!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Input, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "notice notice-info inline below-h2 notice-alt",
                                style: {
                                    margin: 0
                                },
                                children: /*#__PURE__*/ _jsx("p", {
                                    children: __("Please note that we will send you a confirmation e-mail. Only when you have clicked on the activation link in the email will you receive the newsletter.")
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM,
                children: _i(__("Information on the processing of your personal data can be found in our {{a}}privacy policy{{/a}}."), {
                    a: /*#__PURE__*/ _jsx("a", {
                        href: privacyPolicy,
                        target: "_blank",
                        rel: "noreferrer"
                    })
                })
            })
        ]
    });
});
export { PluginUpdateTermFields };
